/**
 * ランダムな文字列を生成します。
 *
 * @param {number} [length=8] 生成する文字列の長さ（デフォルトは8）
 * @returns {string} 生成されたランダムな文字列
 */
export function randomString(length = 8) {
    const alphabets = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const characters = alphabets + '0123456789';
    let result = '';

    // Ensure the first character is always an alphabet
    result += alphabets.charAt(Math.floor(Math.random() * alphabets.length));

    // Generate the remaining characters
    for (let i = 1; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    return result;
}
